<template>
  <div
    @contextmenu="selectComponentDEV($event, schema.model)"
    :class="[schema.invertContent && 'flex-column-reverse', getSelectedDEV && 'dev-selected-component']"
    :key="generateId(schema.model)"
  >
    <v-textarea
      v-model="typed"
      v-bind="schema.attributesTextField"
      :counter="count"
      :maxlength="count"
      :rules="rules"
      :name="schema.model"
      :id="generateId(schema.model)"
      :ref="schema.model"
      :readonly="schema.readonly"
      @blur="onBlur"
      @click:clear="clear()"
      @change="onChange"
      @focus="onFocus"
      @input="onInput"
    >
      <template v-slot:label>
        {{ schema.attributesTextField.label }}
        <span v-if="schema.rules.includes('required')" class="red--text">*</span>
      </template>
    </v-textarea>
    <div>
      <h4
        v-if="schema.attributesTitle.visible"
        v-text="schema.attributesTitle.title"
        v-bind="schema.attributesTitle"
      ></h4>

      <p v-text="initialValue"></p>

      <p v-text="typed"></p>
    </div>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import rulesMixin from '@/mixins/rules-mixin';
import devComponentMixin from '@/mixins/dev-component-mixin';
import componentMixin from '@/mixins/component-mixin';
export default {
  mixins: [abstractField, devComponentMixin, rulesMixin, componentMixin],

  data() {
    return {
      initialValue: this.value,
      typed: '',
      title: null,
      count: null
    };
  },

  created() {
    let count = this.model[`${this.schema.model}_maxlength`];
    this.count = count ? count : this.schema.attributesTextField.counter;
  },

  methods: {
    onChange: function () {
      this.value = `${this.initialValue} ${this.typed}`;
    },

    clear() {
      this.$nextTick(() => (this.model[this.schema.model] = ''));
    }
  }
};
</script>

<style lang="scss" scoped>
.flex-column-reverse {
  display: flex;
  flex-direction: column-reverse;
}
</style>
